import { useProgressReferralModal } from '../model/useProgressReferralModal';
import s from './progress-referral-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal'
import classNames from 'classnames';
import useMedia from 'use-media';

export const ProgressReferralModal = () => {

  const {isOpen, close, modalParams: params } = useProgressReferralModal()

  const currentLevel = params?.referral_level?.id

  const isMobile = useMedia({maxWidth: '768px'})

  return (
		<Modal {...{isOpen, close}}>
        <div className={s.wrapper}>
          <div className={s.container}>
            <h1>Наши уровни</h1>
            <p>Приглашайте преподавателей на платформу и снижайте комиссию. Чем выше уровень, тем меньше процент платформы.</p>
          </div>
          <div className={s.container}>
            {params?.referral_levels.map((level) => (
              <div key={level?.id} className={classNames(s.card,currentLevel === level.id ? s.active : '')}>
                <p className={currentLevel === level.id ? s.activeLevelText : ''}>
                  {currentLevel === level.id ? 'Твой уровень' : 'Заблокировано'}
                </p>
                <div className={s.row}>
                  <div className={s.info}>
                    <h1 className={s.level}>{level?.name}</h1>
                    {isMobile ? <p>Пригласи <span>{level?.min_referrals} преподавателей</span>{' '}и мы <span>снизим комиссию</span></p> : 
                    <p>Пригласи <span>{level?.min_referrals} преподавателей</span><br/>и мы <span>снизим комиссию</span></p>
                    }                  </div>
                  <div className={s.smallCard}>
                    <h1>{level?.commission_percent} %</h1>
                    <span>Наша комиссия</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
		</Modal>
  );
};